import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import PanelControlEstudiosView from './PanelControlEstudiosView';
import * as ROUTES from '../../../router/Routes';

const PanelControlEstudiosModule = () => {
  return (
    <ContainerTemplate active={ROUTES.controlEstudios} routes={[]}>
      <PanelControlEstudiosView />
    </ContainerTemplate>
  );
};

export default PanelControlEstudiosModule;
